export const housekeeping = {
  // ── Page (index) ──
  title: "Ménage",
  remindersBtn: "Rappels",
  refresh: "Actualiser",
  aboutToLeaveTitle: "Clients sur le départ aujourd'hui",
  aboutToLeaveCount: "{count} sur le départ",
  remindersTitle: "Configurer les rappels de nettoyage",

  headline: {
    allDone: "Tout est à jour ! Rien à nettoyer pour le moment.",
    inProgress: "Nettoyage en cours · {count} en cours",
    toClean: "Que faut-il nettoyer aujourd'hui ? {count} à nettoyer",
    toCleanWithProgress: "Que faut-il nettoyer aujourd'hui ? {toClean} à nettoyer · {inProgress} en cours",
  },

  allProperties: "Tous les établissements",
  searchPlaceholder: "Rechercher une chambre, un client…",

  // Status filter chips (label)
  chips: {
    all: "Tous",
    to_clean: "À nettoyer",
    in_progress: "En cours",
    occupied: "Occupé",
    clean: "Disponible",
    out_of_service: "Hors service",
  },
  // Status filter chips (tooltip)
  chipTips: {
    all: "Tous les espaces du jour, sans filtre.",
    to_clean: "Nettoyage en attente : marqué sale, départ aujourd'hui et non nettoyé, ou longs séjours à nettoyer selon leur intervalle.",
    in_progress: "Nettoyage en cours actuellement.",
    occupied: "Client à l'intérieur (séjour en cours, pas de départ aujourd'hui).",
    clean: "Propre et prêt pour le prochain client (y compris les espaces inspectés).",
    out_of_service: "Non disponible au nettoyage (panne ou maintenance).",
  },

  loadingBoard: "Chargement du tableau…",
  emptyToClean: "Tout est propre ! Aucun espace en attente pour le moment.",
  emptyStatus: "Aucun espace dans ce statut.",
  emptySearch: "Aucun espace ne correspond à votre recherche.",

  typeHotel: "Hôtel",
  typeApartment: "Appartement",

  // Row badges
  stayDue: "Nettoyage requis",
  hourlyStayDue: "Séjour horaire terminé",
  hourlyStayAt: "Parti à {time}",
  overdue: "En retard",
  overdueSince: "Pas nettoyée depuis le {date} · {days} jours",
  overdueGuests: "{n} clients sont partis sans nettoyage enregistré",
  // La franja de una estancia por horas en marcha, en la fila del tablero.
  hourlyInUse: "De {from} à {to}",
  // El cliente sigue dentro y su hora de fin ya pasó.
  hourlyOverdue: "Heure dépassée",
  alreadyLeft: "Déjà parti",
  aboutToLeave: "Sur le départ",
  cleanBadge: "Propre",
  inspectedBadge: "Inspecté",

  // Turnover (one leaves / another arrives)
  departs: "↑ Départ",
  arrives: "↓ Arrivée",
  guestFallback: "Client",
  departsOn: "· départ le {date}",

  // Row actions
  assign: "Attribuer",
  reassignTitle: "Réattribuer le responsable du nettoyage",
  assignWhoTitle: "Attribuer le responsable du nettoyage",
  start: "Démarrer",
  startTitle: "Marquer en cours",
  cleanAction: "Nettoyer",
  cleanTitle: "Terminer le nettoyage (photos et notes)",
  tasks: "Tâches",
  tasksTitle: "Tâches et détails",

  toastSaved: "Rappels de nettoyage mis à jour",

  // Effective status (label)
  status: {
    to_clean: "À nettoyer",
    in_progress: "En cours",
    occupied: "En cours d'utilisation",
    clean: "Disponible",
    inspected: "Inspecté",
    out_of_service: "Hors service",
  },
  // Effective status (tooltip)
  statusTip: {
    to_clean: "En attente de nettoyage.",
    in_progress: "Nettoyage en cours.",
    occupied: "En cours d'utilisation : client à l'intérieur.",
    clean: "Propre et prêt pour le prochain client.",
    inspected: "Propre et vérifié par un superviseur.",
    out_of_service: "Hors service : ne peut pas être nettoyé (panne/maintenance).",
  },
  // Occupancy (label)
  occupancy: {
    vacant: "Libre",
    occupied: "Occupé",
    departure_today: "Départ aujourd'hui",
    arrival_today: "Arrivée aujourd'hui",
    turnover: "Départ et arrivée",
  },
  // Occupancy (tooltip)
  occupancyTip: {
    vacant: "Aucun client : libre.",
    occupied: "Client à l'intérieur (séjour en cours).",
    departure_today: "Le client part aujourd'hui : un nettoyage sera nécessaire.",
    arrival_today: "Un client arrive aujourd'hui : doit être prêt à temps.",
    turnover: "Un client part et un autre arrive aujourd'hui : nettoyage urgent entre les deux.",
  },

  roles: {
    limpieza: "Nettoyage",
    mantenimiento: "Maintenance",
    recepcion: "Réception",
    gestor: "Gestionnaire",
    propietario: "Propriétaire",
  },

  // Mid-stay cleaning reason
  stayTip: {
    fallback: "Nettoyage de séjour requis",
    daysSince: "{count} jour | {count} jours",
    interval: "chaque jour | tous les {count} jours",
    main: "Le client est toujours en séjour. Cela fait {since} sans nettoyage, et il doit être nettoyé {interval}.",
  },

  // Cleaning-window timer
  timer: {
    approx: " (env.)",
    overdue: "Arrivée en retard",
    overdueTitle: "L'heure d'arrivée ({checkin}) est dépassée · priorisez ce nettoyage",
    remaining: "{dur} avant l'arrivée",
    remainingTitle: "{dur} restant avant l'arrivée ({checkin})",
  },

  // ── Reminders modal ──
  remind: {
    title: "Rappels de nettoyage",
    subtitle: "Alertez votre équipe lorsqu'une chambre avec une arrivée/un départ à venir n'est pas prête.",
    close: "Fermer",
    scopeLabel: "Quels établissements ?",
    scopeOne: "Cet établissement",
    scopeAll: "Tous",
    summary: "{enabled} établissement(s) sur {total} avec rappels actifs.",
    propertyLabel: "Établissement",
    activeSuffix: " · actif",
    propertyHelp: "Chaque établissement conserve son propre calendrier.",
    allNotePre: "Les mêmes paramètres s'appliqueront à vos ",
    allNotePost: " établissements (chacun à son heure locale).",
    arrivalsTitle: "Arrivées et départs",
    longStayTitle: "Réservations de longue durée",
    daysBeforeLabel: "Combien de temps à l'avance ?",
    daysBefore: {
      same: "Le jour même uniquement",
      upTo: "Jusqu'à {count} jour avant | Jusqu'à {count} jours avant",
    },
    daysBeforeHelp: "Prend en compte les arrivées/départs dans cette fenêtre.",
    intervalLabel: "Combien de jours entre les nettoyages ?",
    interval: "Chaque jour | Tous les {count} jours",
    intervalHelp: "Compté à partir du dernier nettoyage. La chambre apparaîtra sous « À nettoyer » même si elle est encore occupée.",
    timeLabel: "À quelle heure sont-ils envoyés ?",
    timeHelp: "Heure locale de l'établissement. Une fois par jour.",
    recipientsLabel: "Qui est notifié ?",
    note: "Ils sont envoyés via une file d'attente (notification + push) et chaque alerte est enregistrée dans les notifications.",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveAll: "Enregistrer pour tous",
    save: "Enregistrer",
    recipients: {
      assigned: "Attribués",
      team: "Équipe",
      both: "Les deux",
    },
    recipientHelp: {
      assigned: "Uniquement les personnes attribuées à cette chambre.",
      team: "Toute l'équipe de nettoyage/maintenance de l'établissement.",
      both: "Les personnes attribuées et l'équipe de l'établissement.",
    },
    longStayOff: "Désactivé",
    longStaySub: "Chaque jour du séjour | Tous les {count} jours du séjour",
    toggleAllOn: "Sera activé pour tous",
    toggleAllOff: "Sera désactivé pour tous",
    toggleOneOn: "Activé pour cet établissement",
    toggleOneOff: "Désactivé",
  },

  // ── Complete-cleaning modal ──
  complete: {
    title: "Terminer le nettoyage",
    dropStrong: "Glissez les photos ici",
    dropRest: "ou cliquez pour sélectionner",
    dropHint: "Preuve de l'état de la chambre · JPG, PNG, WEBP",
    photoAlt: "photo",
    saved: "Enregistré",
    view: "Voir",
    remove: "Supprimer",
    notes: "Notes",
    notesPlaceholder: "Problèmes, dommages, objets manquants… (facultatif)",
    cancel: "Annuler",
    uploading: "Téléversement… {pct}%",
    saving: "Enregistrement…",
    submit: "Marquer comme propre",
    previewAlt: "aperçu",
  },

  // ── Assign modal ──
  assignModal: {
    title: "Qui nettoie cet espace ?",
    allOption: "Tout le monde",
    allDesc: "Visible par tout le personnel de nettoyage et de maintenance",
    roleSection: "Attribuer à un rôle",
    peopleTitle: "Ou choisir des personnes",
    peopleHint: "(une ou plusieurs)",
    emptyPre: "Vous n'avez pas encore de membres d'équipe. Vous pouvez attribuer par rôle ou ajouter des personnes dans ",
    emptyTeam: "Équipe",
    emptyPost: ".",
    cancel: "Annuler",
    saving: "Enregistrement…",
    save: "Enregistrer l'attribution",
  },

  // ── Planification : le calendrier des ménages à venir ──
  plan: {
    title: "Planification des ménages",
    viewToday: "Aujourd'hui",
    viewPlan: "Planification",
    loading: "Chargement du calendrier…",
    loadError: "Le calendrier n'a pas pu être chargé.",
    saveError: "Impossible d'enregistrer. Réessayez.",
    empty: "Aucun ménage sur ces dates.",
    space: "Espace",
    prev: "Jours précédents",
    next: "Jours suivants",
    today: "Aujourd'hui",
    days: "{n} jours",
    anyone: "N'importe qui",
    unassigned: "Non attribué",
    headline: {
      nothing: "Rien en attente sur ces dates.",
      all: "{total} ménages en attente · {urgentes} urgents",
      withOrphans: "{total} en attente · {urgentes} urgents · {sin} non attribués",
    },
    types: {
      turnover: "Départ et arrivée",
      arrastre: "En retard",
      salida: "Départ",
      estancia: "Long séjour",
      manual: "Marqué à la main",
    },
    abbr: { all: "TOUS", turnover: "TURN", arrastre: "RET", salida: "DEP", estancia: "SEJ", manual: "MAN" },
    windowGuessed: "Horaires par défaut : ce logement n'a pas les siens",
    legendTight: "Marge serrée entre le départ et l'arrivée",
    noRoomTip: "{n} départs sans chambre encore attribuée",
    windowTip: "Entre le départ ({desde}) et l'arrivée ({hasta}), il y a {min} minutes",
    roleShort: "RÔLE",
    roleFull: "Attribué à un rôle, pas à une personne",
    fromSpace: "attribution fixe de l'espace",
    nobody: "Non attribué — cliquez pour choisir quelqu'un",
    dow: { mon: "L", tue: "M", wed: "M", thu: "J", fri: "V", sat: "S", sun: "D" },

    teamRows: "Charge de l'équipe",

    teamTitle: "Équipe",
    capacity: "Capacité",
    capacityTitle: "Combien de ménages chaque personne peut faire par jour",
    done: "Terminé",
    perDay: "Par jour",
    dayOffTip: "Marquer comme jour de repos",
    noStaff: "Vous n'avez pas encore de personnel de ménage. Ajoutez des personnes dans Équipe et leur charge s'affichera ici.",
    shortHands: "Il manque des bras : {dias}",
    loadTip: "{dia} : {n} sur {cap}",
    loadTipOff: "{dia} : jour de repos ({n} attribués)",
    hasNow: "{n} attribués · tient {cap} par jour",

    selected: "{n} sélectionnés",
    assignTo: "Attribuer à…",
    assignBtn: "Attribuer {n}",
    people: "Personnes",
    noteTitle: "Note pour ce ménage",
    notePlaceholder: "Arrive tard, à prioriser…",
    unassign: "Retirer",
    clear: "Désélectionner",
    assigned: "{n} ménages attribués",
    unassigned2: "Attribution retirée",
    partial: "{n} attribués, {mal} n'ont pas pu l'être",
    autoAssign: "Répartir automatiquement",
    nothingToAssign: "Rien de non attribué sur ces dates.",
    proposalTitle: "Proposition de répartition",
    proposalSub: "{n} ménages répartis. Vérifiez avant d'appliquer.",
    proposalApply: "Appliquer la répartition",
    proposalUncovered: "{n} non couverts",
    cancel: "Annuler",
    uncovered: {
      nadie_tiene_esta_propiedad: "personne n'a ce logement attribué",
      nadie_trabaja_ese_dia: "personne ne travaille ce jour-là",
      equipo_lleno: "l'équipe est à sa limite",
    },
    rejected: {
      espacio_ajeno: "Cet espace n'appartient pas à votre compte.",
      persona_ajena: "Cette personne ne fait pas partie de votre équipe.",
      persona_sin_la_propiedad: "Cette personne n'a pas ce logement attribué. Attribuez-le d'abord dans Équipe.",
      rol_desconocido: "Ce rôle n'existe pas.",
      datos_incompletos: "Des données du ménage manquent.",
      error_al_guardar: "Impossible d'enregistrer.",
    },
    autoAssignN: "Répartir {n}",
    seeDay: "Voir la journée",
    filtering: "Filtré par",
    showingOf: "{n} sur {total} affichés",
    emptyFiltered: "Aucun résultat avec ces filtres. Il y a {total} ménages sur ces dates.",
    moreFilters: "Plus de filtres",
    roomy: "Confort",
    dense: "Compact",
    ofN: "sur {n} ménages",
    addPerson: "Ajouter quelqu'un à l'équipe",
    notCleaner: "Pas du personnel de ménage, mais a du travail attribué",
    teamCap: "{n} par jour",
    teamFoot: "La charge couvre toute la période ; les filtres ne la changent pas.",
    perDayN: "{n} par jour",
    closedN: "{n} clôturés",
    capMax: "Le maximum est de {n} par jour",
    rowHint: "Alt + clic pour choisir toute la ligne",
    daySheetTip: "Cliquez pour voir la journée · Alt + clic pour tout choisir",
    keysHint: "1-9 attribue · A ouvre · Échap efface",
    undo: "Annuler",
    undone: "Répartition rétablie",
    tightDay: "{dia} compte {n} ménages",
    tightMore1: "et 1 jour de plus",
    tightMoreN: "et {n} jours de plus",
    proposalDetail: "Voir la répartition ménage par ménage",
    nobody2: "Personne pour l'instant",
    warnDayOff: "{quien} est en repos le {dia}.",
    warnOver: "{quien} passe à {n} le {dia} et tient {cap}.",
    onDay: "{dia} : {n} + {mas} sur {cap}",
    onDays: "{dias} jours : {n} sur {cap}",
    c: {
      pending: "En attente",
      urgent: "Urgents",
      tight: "Journées serrées",
      done: "Faits",
      noRoom: "Sans chambre",
    },
    rows: {
      withWork: "avec travail",
      all: "tous",
      help: "« Tous » affiche aussi les espaces qui n'ont pas de ménage sur ces dates.",
      forced: "Avec un filtre actif, seuls les espaces qui ont du travail sont affichés.",
    },
    f: {
      any: "Indifférent",
      urgency: "Urgence",
      window: "Créneau",
      state: "État",
      unitType: "Type d'espace",
      clear: "Effacer les filtres",
    },
    urg: {
      urgente: "Quelqu'un arrive ce jour-là",
      alta: "Quelqu'un arrive le lendemain",
      normal: "Quelqu'un arrive dans 2-3 jours",
      baja: "Personne n'arrive après",
    },
    holg: { amplia: "Large", justa: "Serré", imposible: "Pas le temps" },
    estados: { pendiente: "En attente", en_curso: "En cours", hecha: "Fait", fuera_de_servicio: "Hors service" },
    motivos: {
      faltan_manos: "il manque {n} bras",
      con_hora_limite: "{n} avec heure limite",
      varios_edificios: "{n} bâtiments différents",
    },
    sheet: {
      autoDay: "Répartir cette journée",
      assignAll: "Attribuer les {n}",
      nCleanings: "{n} ménages",
      nUnassigned: "{n} non attribués",
      covers: "l'équipe couvre {n}",
      empty: "Rien à nettoyer ce jour-là.",
    },
    tip: {
      outIn: "départ · arrivée",
      lateSold: "départ tardif vendu",
      earlySold: "arrivée anticipée",
      noName: "Sans nom",
      pax: "{n} pers.",
      nights: "{n} nuits",
      min: "{n} min",
      h: "{h} h",
      hm: "{h} h {m}",
      stillIn: "toujours sur place",
      freeNobody: "reste libre",
      freeNone: "quelqu'un arrive",
      freeDay1: "libre 1 jour",
      freeDaysN: "libre {n} jours",
      houseHours: "horaires par défaut",
      openSpace: "Fiche de l'espace", openSpaceHint: "S'ouvre dans le tableau d'Aujourd'hui, avec son état, ses tâches et son historique",
      select: "Choisir",
      deselect: "Retirer de la sélection",
      assignedBy: "Attribué par {quien}",
    },
  },
};
